import { Component, effect, Inject, inject, Injectable, LOCALE_ID, signal } from '@angular/core';
import { UserService } from '../../user.service';
import { CommonModule, registerLocaleData } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';
import { UserInfo } from '../../user-info/user-info';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CommunityCalendar } from '../community-calendar/community-calendar';
import localeJa from '@angular/common/locales/ja';

// Register Japanese locale
registerLocaleData(localeJa);

//create a payments service here
@Injectable({ providedIn: 'root' })
export class PaymentsService {
	public Current_balance = signal<number>(20000);
	public Next_Payment_Date = signal<Date>(new Date(Date.now() + 14 * 24 * 60 * 60 * 1000));
	public language = signal<number>(1);

	public pastPayments = signal([
		{ date: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000), amount: 20000 },
		{ date: new Date(Date.now() - 60 * 24 * 60 * 60 * 1000), amount: 20000 },
		{ date: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000), amount: 20000 },
	]);

	constructor( protected _userService: UserService ) {
		//initialize service
		effect(() => {
			const tenant = this._userService.currentTennant();
			this.language.set( tenant ? tenant.Language : 1 );
		});
	}
	//add methods to get payment data from server
}



@Component({
  selector: 'app-payments-overview',
  imports: [RouterLink, FormsModule, CommonModule],
  templateUrl: './payments-overview.html',
  styleUrl: './payments-overview.scss'
})
export class PaymentsOverview {

	public pastPayments = inject(PaymentsService).pastPayments;

	protected language: number = 2;
	protected currentLocale: string = 'en-US';

	constructor( public paymentsService: PaymentsService, protected userService: UserService, protected sanitizer: DomSanitizer) {
		effect(() => {
			//can add any reactive logic here if needed
			const tenant = this.userService.currentTennant();
			this.language = tenant.Language;
			this.currentLocale = this.language == 2 ? 'ja' : 'en-US';
		});
	}

	contentStrings : Record<string, Record<number, string>> = {
		Payments: { 1: "Payments", 2: "支払い" },
		YourCurrentBalance: { 1: "Your current balance:", 2: "現在の残高：" },
		ScheduledPaymentMessage: { 1: "You have scheduled a payment of your full balance", 2: "全額の支払いが予定されています" },
		PaymentDate: { 1: "Payment Date:", 2: "支払日：" },
		ShowDetails: { 1: "Show Details", 2: "詳細を表示" },
		PayNow: { 1: "Pay Now", 2: "今すぐ支払う" },
		SchedulePayment: { 1: "Schedule Payment", 2: "支払いを予定する" },
		ChangeScheduledPayment: { 1: "Need to change your scheduled payment?", 2: "予定されている支払いを変更しますか？" },
		ClickHereToChange: { 1: "Click here to change my scheduled payment.", 2: "ここをクリックして予定されている支払いを変更してください。" },
		PastPayments: { 1: "Past Payments", 2: "過去の支払い" },
		GoToPaymentHistory: { 1: "Go to payment history...", 2: "支払い履歴を見る..." },
	}

}
